import {
    SET_CURRENT_SCENE,
    REQUEST_SCENES, RECIEVE_SCENES
} from '../constants/actionTypes';

const initialState = {
    current: "",
    all: [],
    fetchingScenes: false
};

const scene = (state = initialState, action) => {
    switch(action.type) {
        case SET_CURRENT_SCENE:
            return {
                ...state,
                current: action.scene
            };
        
        case REQUEST_SCENES:
            return {
                ...state,
                fetchingScenes: true,
                all: []
            };

        case RECIEVE_SCENES:
            return {
                ...state,
                fetchingScenes: false,
                all: action.scenes
            };

        default:
            return state;
    }
};

export default scene;



// WEBPACK FOOTER //
// ./src/reducers/scene.js